import { AlertBoxBase, cn } from "@jog/react-components";
export const AlertBox = ({ text, type, className }) => (<AlertBoxBase type={type || "default"} className={cn("text-sm", className)} text={text}/>);
